/* global urlify getPageUrl */
import $ from "jquery";
import language from "./translation";
import { articlesExtend, setCorrectTemplate } from "./general_functions";

// GET, SET
export const getStoredNav = () => {
    /*
    Gets the categories from SessionStorage, parse them and return as JSON
    */
    return JSON.parse(sessionStorage.getItem("aim-categories"));
};

export const storeNav = (categories, counts) => {
    /*
    Receive cateogories (initiated in app.js). Process data and concats it with the articlecount. 
    Store result in Session Storage, parsed as string.
    */

    const loopCategories = (categories, parent) => {
        // loops trought the categories and place the aritcle count on each category. Calls itself on child.
        // return as JSON

        let count = 0;
        $.each(categories, (nr, data) => {

            $.each(counts, function() {
                if ($(this)[0].value === data.categoryId) {
                    // count = $(this)[0].key;
                }
            });

            // check children_names as replacement for category description.
            let names = [];
            $.each(data.children, function(children_nr, children_data) {
                names.push((children_data.previewItem ? children_data.previewItem : children_data.item));
            });
            names = names.join(", ");

            // sets additional data

            let internurl = data.previewItem ? data.previewItem : data.item;

            data.looped = true;
            data.articles = count;
            data.urlified = urlify(internurl.toLowerCase());

            // console.log("data nav", data)

            data.desc = data.description;
            if (data.description === " " || data.description === null || data.description === "") {
                // console.log("has space or null");
                data.desc = names;
            }


            if (parent) {
                data.full_url = parent.full_url + "/" + urlify(internurl.toLowerCase());
            }
            else {
                data.full_url = urlify(internurl.toLowerCase());
            }

            // initiate drilldown on children
            if (data.children) {
                if (data.children.length > 0) {
                    loopCategories(data.children, data);
                }
            }
            // console.log(data.item, data.desc, data.description);
        });

        return categories;
    };

    categories = loopCategories(categories);

    // console.log(categories);

    sessionStorage.setItem("aim-categories", JSON.stringify(categories));

};

export const getNavPosition = (searchfor) => {
    /*
    Creates a array of a single "cateogory". 
    Return as Array 
    */

    let navs = getStoredNav();
    let returnValues = [];
    traverseNavigation(navs, searchfor, returnValues);
    
    return returnValues;
};

export const traverseNavigation = (navs, searchfor, returnValues) => {
    $.each(navs, function(nr, nav) {
        let searchParts = searchfor.split('/');
        if (nav.full_url === searchfor) {
            // Found it, you can quit now
            returnValues.push(nav);
            return false;
        }
        else if(searchParts.includes(nav.urlified)){
            returnValues.push(nav);
            traverseNavigation(nav.children, searchfor, returnValues);
        }
    });
}

export const getNavArticles = (category) => {
    /*
    Get articles from current cateogry. 
    Return HTML injection. 
    */

    let config = JSON.parse(sessionStorage.getItem("config"));

    let senddata = JSON.stringify({
        "categoryId": category,
        "subscriptionId": config.clientId
    });

    // Get JSON
    $.ajax({
        type: "POST",
        url: window.apiUrl + "/api/PublicContentApi/getbycategoryidasstring",
        contentType: "application/json-patch+json",
        data: senddata,
    }).done(function(alle) {

        let allArticles = [];
        let allUnits = [];

        $.each(alle, function(nr, article) {

            // Handle intro textx

            // Intro step 1: Get intro, reduce to max 100 char.
            let intro = article.intro || "";
            if (intro.length >= 100)
                intro = intro.substr(0, 97) + "...";

            // Intro step 2: Set Intro to tags
            if (intro === "") {

                let tags = [];
                $.each(tags, function(n, tag) {
                    let title = tag.title;
                    title = title.charAt(0).toUpperCase() + title.slice(1);
                    tags.push(title);
                });
                tags = tags.join(" - ");

                intro = tags;
            }

            // intro step 3: Set intro to block headers.
            let content = decodeURIComponent(article.contentObject);
            if (intro === "") {
                let parts = [];
                let reg = /\[.*\]/g;
                let result;
                while ((result = reg.exec(content)) !== null) {
                    parts.push(result);
                }
                intro = parts.join(" - ");
            }

            if (intro.length >= 100) {
                intro = intro.substr(0, 97) + "...";

            }
            if (intro.length >= 1) {
                // intro cleanup
                intro = intro.replace(/\[|\]/gi, "");
            }

            // intro step 4: get first 100 char from article
            if (intro === "") {

                function stripHtml(html) {
                    var tmp = document.createElement("DIV");
                    tmp.innerHTML = html;
                    return tmp.textContent || tmp.innerText || "";
                }

                content = stripHtml(content);
                intro = content.substr(0, 97) + "...";
            }

            let desc = intro || "";


            article = articlesExtend(article);

            if (article.metaParsed && article.pageTypeId === "mal_dynamisk") {
                let metaArticleTypeId = setCorrectTemplate(article.metaParsed);
                if (metaArticleTypeId) {
                    article.pageTypeId = metaArticleTypeId;
                }
            }

            // return only if not block
            if (article.pageTypeId !== "mal_blokk" 
                    && article.pageTypeId !== "mal_dynamisk" 
                    && article.pageTypeId !== "mal_nyhet" 
                    && article.pageTypeId !== "bti-forside"
                    && !article.isVisibleInNavigation===false) {
                let nav = {
                    article: article,
                    item: article.title,
                    articles: 0,
                    desc: desc,
                    type: article.pageTypeId
                };

                if (nav.type !== "mal_enhetsmal") {
                    allArticles.push(menuItemHtml(nav, true));
                }
                else {
                    allUnits.push(menuItemHtml(nav, true));
                }



            }

        });

        allArticles.sort();
        allArticles.join("");

        allUnits.sort();
        let allUnits_length = allUnits.length;
        allUnits = allUnits.join("");

        $("#menuitems").append(allArticles);

        if (allUnits_length > 0) {
            $("#menuitem_link").html(`
                <a href='#allunits' class="fullnav__allunitslink"><span class='budlight-arrow-bottom'></span>${language("NAV_UNITS_IN_MUNIC")}</a>
            `)
            $("#menu_units").append(`
                <div class="unitscontainer col-12">
                    <h2 id='allunits' class="fullnav__unitheader">${language("NAV_UNITS_IN_MUNIC")}</h2>
                    <div class="units">
                        <div class="row">
                            ${allUnits}
                        </div>
                    </div>
                </div>
            `)
        }

        $(".temp__spinner").remove();

    });

};

export const navPage = () => {
    /*
    Sets navPage, (initiated in app.js)
    return HTML to app.js
    */


    let breadcrumbs = [];
    // get categoryposition
    let path = getNavPosition(getPageUrl().contentid);
    let last;

    // set breadcrumbs based on position
    $.each(path, function(nr, page) {

        // console.log(page);

        let bclink = `<a href="/nav/${page.full_url}" class="fullnav__breadcrumb__link">${page.previewItem ? page.previewItem : page.item}</a>`;

        if (window.location.pathname === "/nav/" + page.full_url) {
            bclink = `<span class="fullnav__breadcrumb__link">${page.previewItem ? page.previewItem : page.item}</span>`
        }

        breadcrumbs.push(`
            <li class="breadcrumb-item">${bclink}</li>
        `);

        last = page;

    });

    breadcrumbs = breadcrumbs.join("");

    let menuItems = [];

    // fallback if no position, initate main-menu
    if (typeof last === "undefined") {
        last = {
            item: language("NAV_MAINMENU"),
            desc: "",
            description: "",
            id: ""
        };
        menuItems = headerNav(true);

    }
    else {

    $.each(last.children, function(nr, child_item) {

        if (child_item.type !== "mal_enhetsmal")
            menuItems.push(menuItemHtml(child_item, true));

    });

    menuItems = menuItems.join("");

    }

    getNavArticles(last.categoryId);

    let r = `     

        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="fullnav__breadcrumb__container">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb fullnav__breadcrumb"  id="full__breadcrumb">

                            <li class="breadcrumb-item"><a href="/" class="fullnav__breadcrumb__link">${language("NAV_FRONTPAGE")}</a></li>
                            <li class="breadcrumb-item"><a href="/nav" class="fullnav__breadcrumb__link">${language("NAV_ALLCATEGORIES")}</a></li>
                            ${breadcrumbs}
                          </ol>
                          <!-- warning position -->
                        </nav>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="fullnav__header">
                        <h1>${last.previewItem ? last.previewItem : last.item}</h1>
                        ${last.description ? last.description : ""}
                        <div id="menuitem_link"></div>
                    </div>
                </div>
            </div>
            <div class="row" id="menuitems">
                ${menuItems}
                
                <div class="temp__spinner col-sm-12 text-center">
                    <div class="spinner-border" role="status" >
                      <span class="sr-only">Loading...</span>
                    </div>
                </div>
                
            </div>
            <div class="row" id="menu_units">
            </div>
            <div class="row" id="nav__items">
            </div>
        </div>

    `;

    return r;

};



export const menuItemHtml = (nav, reversed = false) => {
    /*
    Create a reusable HTML element for nav Item. 
    Contains logic to seperate href and color-variations
    Return HTML
    */
    let href = '/nav/' + nav.full_url;
    const article = nav.article || false;
    // let externalLink = nav.externallink != undefined && nav.externallink != "";
    let target = '""';
    let isRealExternalLink = false;
    if (article) {
        href = '/artikkel/' + (article.nameInUrl || article.contentId);
        if (nav.type === 'externalnavlink') {
            const url = nav.article.metaDynamic['Ekstern lenkeadresse / URL'];
            href = url;
            target = 'target="_blank"';
        }
    } else if (nav.externallink) {
        href = nav.externallink;
        const regex = /^https?:\/\//;
        if (regex.test(nav.externallink)) {
            isRealExternalLink = true;
            nav.type = "externallink";
            target = 'target="_blank"';
        }
    }
    const navCols = (client.style !== undefined && client.style.fullnav__row_wide) ? 2 : 3;
    const transCols = (client.style !== undefined && client.style.transport__row_wide) ? 2 : 3;
    const externallinkCols = (client.style !== undefined && client.style.fullnav__externallink__row_wide) ? 2 : 3;
    let cols = reversed ? transCols : navCols;
    cols = isRealExternalLink ? externallinkCols : cols;

    return `<div class="col-md-${cols === 2 ? 6 : 4} col-sm-6 mb-3 mb-md-4" data-name="${urlify(nav.item)}">
                <a href="${href}" ${target} class="fullnav__main__item h-100 ${reversed ? 'fullnav__main__item-reversed' : ''} fullnav__main__item-${nav.type}">
                    <h2 class="fullnav__main__title"><span class="fullnav__main__titletext">${nav.previewItem ? nav.previewItem : nav.item}${nav.articles > 0 ? ' ' : ''}</span><span class="material-icons-outlined menu-icon ${isRealExternalLink ? 'externallink' : ''}"></span></h2>
                    ${nav.desc ? `<p>${nav.desc}</p>` : ''}
                </a>
            </div>`; // (${nav.articles})
};

export const headerNav = (reversed = false) => {
    /*
    Create main navigation to header and "empty site"
    Simple logic to work with two styles with "reversed"
    Return HTML.
    */

    var navs = getStoredNav();
    let menu_items = [];
    let menu_items_externallinks = [];

    $.each(navs, function(nr, nav) {
        // console.log(nav);
        if(nav.externallink) {
            nav.type = "articlelink";
            let regex = /^https?:\/\//;
            if(regex.test(nav.externallink))
                nav.type = "externallink";
            }
        if (nav.type !== "mal_enhetsmal")
            menu_items.push(menuItemHtml(nav, reversed));
        else if (nav.type == "externallink" && !nav.previewItem.startsWith("_"))
            menu_items_externallinks.push(menuItemHtml(nav, reversed));
    });

    menu_items = menu_items.join("");
    if(menu_items_externallinks)
        menu_items = `${menu_items}<div class="col-12 menu-spacer"></div>${menu_items_externallinks.join("")}`;
    return menu_items;

};
